"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Col = require("./Col");
Object.keys(_Col).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Col[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Col[key];
    }
  });
});
var _Row = require("./Row");
Object.keys(_Row).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Row[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Row[key];
    }
  });
});